import { AllSectionsQuery } from '../../queries/all_sections_query';
import { TransientAccessCredEventNames } from '../../../../prevent_transient_access/constants/transient_access_cred_constants';
import { PreventTransientAccessQuery } from '../../../../prevent_transient_access/queries/prevent_transient_access_query';
import { TermScheduleFlags } from '../../services/term_schedule_flags';
import { TermCourseServant } from '../../../term_courses/servants/term_course_servant';
import { ScheduledSectionStatusServant } from '../../servants/scheduled_section_status_servant';
import { ICommand } from 'core-ts-types';
import { MultiSectionServant } from '../../servants/multi_section_servant';
import {
  ISection,
  IMenuAction,
  TMenuItems,
  IMenuSettings,
  IMenuItem
} from '../../../../interfaces/scheduler_interfaces';
import { SectionInfoServant } from '../../../sections/servants/section_info_servant';
import { ScheduledSectionServant } from '../../servants/scheduled_section_servant';
import { ScheduledSectionStatus } from '../../types/scheduled_section_status_enum';
import { SectionTileMenuEnum } from '../../types/section_tile_menu_enum';
import * as _4 from 'lodash4';
import { SectionSwapServant } from '../../../../swap/servants/section_swap_servant';
import { CrossCourseLinkedSectionServant } from '../../servants/cross_course_linked_section_servant';
import { DropCourseFacade } from '../../../registration/facades/drop_course_facade';
import { CommunicatorService } from 'ui-ng-component-communicator';
import { UnscheduleSectionFacade } from '../../../registration/facades/unschedule_section_facade';
import { UpdateTransientAccessCredWorkflowCommand } from '../../../../prevent_transient_access/commands/update_transient_access_cred_workflow_command';
import { SchedulerCustomTextQuery } from '../../queries/scheduler_custom_text_query';
import { Strategy } from 'utility-ts-strategy';
import { RefreshSeatAvailabilityFacade } from '../../facades/refresh_seat_availability_facade';
import { SelectedSectionActionsFacade } from '../../facades/selected_section_actions_facade';
import { RegisteredSectionServant } from '../../servants/registered_section_servant';
import { RequestStateQuery } from '../../../../request_state/queries/request_state_query';
import { ScheduledSectionRequestStateCommand } from '../../../../request_state/commands/scheduled_section_request_state_command';

export class ScheduledSectionMenu {
  private section: ISection;
  private modalTitle: string;
  private modalBody: string;
  private modalButtonText: string;
  private dropCourseModal: any;
  private isSectionRegistered: boolean;
  private isRegisteredInProgressNotDroppable: boolean;
  private isWaitlistedNotDroppable: boolean;
  private isRegisteredRTRSchool: boolean;
  private registeredInProgressLinkedSections: ISection[];
  private hasEnforcedRegisteredInProgressCoreqsRelated: boolean;
  private label: string = '';
  private swapMode: boolean = false;
  private swapFeatureEnabled: boolean = false;
  private sectionPins = {};
  private crossCourseLinkedSectionIds: number[] = [];
  private registeredEnforcedCoreqs: number[] = [];
  private linkedCourseIds: number[];
  private totalCoursesToDropCount: number = 0;
  private isPermissionPinsFeatureEnabled = false;
  private shouldShowSwapOptions = false;
  private showDropCourseLabel: boolean = false;
  private showDropCoreqMenuOption: boolean = false;
  private courseCoreqLinkedSections: number[] = [];
  private closeModalBound = this.closeModal.bind(this);
  private dropCourseBound: (action: IMenuAction) => void;

  private menuId: string;
  private scheduledSectionMenuItems: TMenuItems;
  private scheduledSectionMenuSettings: IMenuSettings;
  private showScheduledSectionMenu: boolean;
  private isMenuDisabled: boolean;

  private calendarSchedulerSectionButton: IMenuItem;

  constructor(
    private ngScheduledSectionStatusServant: ScheduledSectionStatusServant,
    private ngTermCourseServant: TermCourseServant,
    private ngTermScheduleFlags: TermScheduleFlags,
    private getTermPinCommand: ICommand,
    private ngUnscheduleSectionFacade: UnscheduleSectionFacade,
    private saveSwapFromSectionCommand: ICommand,
    private saveTermPinCommand: ICommand,
    private $stateParams: ng.ui.IStateParamsService,
    private $state: ng.ui.IStateService,
    private $modal: any,
    private $scope: ng.IScope,
    private ngMultiSectionServant: MultiSectionServant,
    private ngScheduledSectionServant: ScheduledSectionServant,
    private ngCrossCourseLinkedSectionServant: CrossCourseLinkedSectionServant,
    private ngSectionInfoServant: SectionInfoServant,
    private ngSectionSwapServant: SectionSwapServant,
    private ngDropCourseFacade: DropCourseFacade,
    private ngAllSectionsQuery: AllSectionsQuery,
    private ngSchedulerCustomTextQuery: SchedulerCustomTextQuery,
    private ngPreventTransientAccessQuery: PreventTransientAccessQuery,
    private updateTransientAccessCredWorkflowCommand: UpdateTransientAccessCredWorkflowCommand,
    private ngComponentCommunicatorService: CommunicatorService,
    private ngRefreshSeatAvailabilityFacade: RefreshSeatAvailabilityFacade,
    private ngRegisteredSectionServant: RegisteredSectionServant,
    private ngRequestStateQuery: RequestStateQuery,
    private scheduledSectionRequestStateCommand: ScheduledSectionRequestStateCommand
  ) {}

  /* TODO: Refactor reduce complexity */
  /* tslint:disable */
  initialize() {
    /*
      Disable menu if section cannot be registered
      Hide the menu for sections that are Completed/InProgress.
    */

    this.showScheduledSectionMenu = true;
    this.isRegisteredInProgressNotDroppable = this.getIsRegisteredInProgressNotDroppable();
    this.isWaitlistedNotDroppable = this.getIsWaitlistNotDroppable();
    this.isRegisteredRTRSchool = this.getIsRegisteredRTRSchool();
    this.showScheduledSectionMenu = this.determineShowScheduledSectionMenu();

    this.registeredEnforcedCoreqs = this.ngScheduledSectionStatusServant.isCoreqEnforcementEnabled()
      ? this.ngScheduledSectionServant.getRegisteredCoreqsRelated(this.section, this.ngAllSectionsQuery.result)
      : [];
    // If dropping a course coreq, also drop linked sections as well
    _4.each(this.registeredEnforcedCoreqs, (coreq: ISection) => {
      const sectionCoreqs = this.ngCrossCourseLinkedSectionServant.getSectionIdOfLinkedCrossCourses(
        coreq.id,
        this.ngAllSectionsQuery.result
      );
      this.courseCoreqLinkedSections = _4.uniq(_4.concat(this.courseCoreqLinkedSections, sectionCoreqs));
    });

    // Check if has linked sections
    this.crossCourseLinkedSectionIds = this.ngCrossCourseLinkedSectionServant.getSectionIdOfLinkedCrossCourses(
      this.section.id,
      this.ngAllSectionsQuery.result
    );

    this.crossCourseLinkedSectionIds = _4.uniq(
      _4.concat(this.crossCourseLinkedSectionIds, this.courseCoreqLinkedSections)
    );

    this.registeredInProgressLinkedSections = _4.filter(
      this.ngCrossCourseLinkedSectionServant.getSectionsByIds(
        this.crossCourseLinkedSectionIds,
        this.ngAllSectionsQuery.result
      ),
      (section: ISection) =>
        section.status === ScheduledSectionStatus.REGISTERED || section.status === ScheduledSectionStatus.IN_PROGRESS
    );
    this.linkedCourseIds = _4.uniq(_4.map(this.registeredInProgressLinkedSections, 'course'));

    this.hasEnforcedRegisteredInProgressCoreqsRelated =
      this.ngScheduledSectionStatusServant.isCoreqEnforcementEnabled() && _4.size(this.registeredEnforcedCoreqs) > 0;

    this.swapMode = this.ngSectionSwapServant.isInSwapMode();
    this.swapFeatureEnabled = this.ngSectionSwapServant.isSwapFeatureEnabled();
    this.isPermissionPinsFeatureEnabled = this.ngSectionSwapServant.isPermissionPinsFeatureEnabled();
    this.shouldShowSwapOptions =
      this.swapFeatureEnabled &&
      this.ngScheduledSectionStatusServant.isDroppable(this.section) &&
      this.ngScheduledSectionServant.isSectionRegistered(this.section);
    this.showDropCoreqMenuOption =
      this.ngScheduledSectionServant.isSectionRegistered(this.section) &&
      (this.hasEnforcedRegisteredInProgressCoreqsRelated || !_4.isEmpty(this.linkedCourseIds));
    const courseIdsToDrop = _4.uniq(
      _4.concat(this.linkedCourseIds, _4.map(this.registeredEnforcedCoreqs, 'course'), [this.section.course])
    );
    this.totalCoursesToDropCount = courseIdsToDrop.length;
    this.buildScheduledSectionMenu();
    this.calendarSchedulerSectionButton = this.getCalendarScheduledSectionButton();
    this.resetTransientCredWorkflow();
  }

  private getIsRegisteredInProgressNotDroppable() {
    return (
      this.ngScheduledSectionServant.isSectionRegistered(this.section) &&
      (!this.ngScheduledSectionStatusServant.isDroppable(this.section) ||
        !this.ngScheduledSectionStatusServant.hasDropDates(this.section))
    );
  }

  private getIsWaitlistNotDroppable() {
    return (
      this.ngScheduledSectionStatusServant.isStatusWaitlisted(this.section) &&
      !this.ngScheduledSectionStatusServant.isDroppable(this.section)
    );
  }

  private getIsRegisteredRTRSchool() {
    return (
      this.ngScheduledSectionServant.isSectionRegistered(this.section) &&
      !this.ngTermScheduleFlags.isOneClickRegistrationEnabled()
    );
  }

  private determineShowScheduledSectionMenu() {
    const canScheduleAgain = _4.get(this.section, 'is_repeatable', false);
    const canWithdraw = this.ngScheduledSectionStatusServant.canWithdraw(this.section);
    const isSectionWithdrawn = this.ngScheduledSectionServant.isSectionWithdrawn(this.section);
    const isSectionRegisteredInProgressAndImmutable =
      this.isRegisteredInProgressNotDroppable && !canScheduleAgain && !canWithdraw;
    this.isMenuDisabled =
      isSectionRegisteredInProgressAndImmutable ||
      this.isWaitlistedNotDroppable ||
      this.ngScheduledSectionStatusServant.isStatusPending(this.section);
    const isSectionCompletedAndImmutable =
      this.ngScheduledSectionStatusServant.isStatusCompleted(this.section) && !canScheduleAgain && !canWithdraw;

    const shouldHideMenu =
      isSectionCompletedAndImmutable ||
      isSectionRegisteredInProgressAndImmutable ||
      this.isRegisteredRTRSchool ||
      isSectionWithdrawn ||
      this.isMenuDisabled;

    return !shouldHideMenu;
  }

  $onInit() {
    this.initialize();
  }

  $onDestroy() {
    this.resetTransientCredWorkflow();
  }

  $onChanges() {
    this.initialize();
  }

  getSectionLabel(section: ISection) {
    return this.ngSectionInfoServant.getSectionLabel(section);
  }

  resetTransientCredWorkflow() {
    this.updateTransientAccessCredWorkflowCommand({
      enabled: true
    });
  }

  disableTransientCredWorkflow() {
    this.updateTransientAccessCredWorkflowCommand({
      enabled: false
    });
  }

  // Drop Confirmation Modal.
  /* tslint:disable:cyclomatic-complexity */
  /* tslint:disable:cognitive-complexity */
  dropUnscheduleAllPrompt(action: IMenuAction) {
    let sectionType = '';

    const enforced_coreq_registered_in_progress_sections_message: string = ``;
    let dropButtonLabel = `Drop Course`;
    this.showDropCourseLabel = false;
    dropButtonLabel = this.totalCoursesToDropCount > 1 ? `Drop ${this.totalCoursesToDropCount} Courses` : `Drop Course`;

    this.resetTransientCredWorkflow();
    if (TermCourseServant.isMultiSectionCourse(this.section._course)) {
      sectionType = `(${this.section._section_type.name})`;
    }
    // FIXME: Use strategy pattern
    if (action.id === SectionTileMenuEnum.DROP_COURSE) {
      this.showDropCourseLabel = true;
      this.modalTitle = `Drop Course`;
      this.modalButtonText = `${dropButtonLabel}`;
    }
    if (action.id === SectionTileMenuEnum.DROP_ENFORCED_COREQS) {
      dropButtonLabel = `Drop ${this.totalCoursesToDropCount} course${this.totalCoursesToDropCount > 1 ? 's' : ''}`;
      this.showDropCourseLabel = true;
      this.modalTitle = `Drop Course and Corequisites`;
      this.modalButtonText = `${dropButtonLabel}`;
    }
    if (action.id === SectionTileMenuEnum.DROP_SECTIONS) {
      this.modalTitle = `Drop Course`;
      this.modalBody = `All enrolled sections for <strong class="text-bold"> ${this.section._course.cd} ${this.section._course.title}</strong> will be dropped.`;
      this.modalButtonText = `${dropButtonLabel}`;
    }
    if (action.id === SectionTileMenuEnum.UNSCHEDULE_SECTIONS) {
      this.isPermissionPinsFeatureEnabled = false;
      this.modalTitle = `Are you sure you want to unschedule all sections?`;
      this.modalBody = `All scheduled sections for <strong class="text-bold"> ${this.section._course.cd} ${this.section._course.title}</strong> will be unscheduled:`;
      this.modalButtonText = `Unschedule Course`;
      this.disableTransientCredWorkflow();
    }
    if (action.id === SectionTileMenuEnum.REMOVE_WAITLIST) {
      this.modalTitle = `Remove from Waitlist`;
      this.modalBody = `<p>Are you sure you want to remove yourself from the waitlist for the following course?</p><strong class="text-bold"> ${this.section._course.cd} ${this.section._course.title} ${sectionType}</strong>`;
      this.modalButtonText = `Remove From Waitlist`;
    }
    this.$scope.$ctrl = this;
    this.$scope.action = action;

    // FIXME: Use route based Modal.
    this.dropCourseModal = this.$modal({
      title: this.modalTitle,
      content: this.modalBody,
      template:
        'capability-ng-scheduler/src/views/course_scheduler/components/scheduled_section_menu/drop_unschedule_confirmation.html',
      scope: this.$scope,
      backdrop: 'static',
      show: false,
      html: true,
      disableAutoFocus: true
    });
    this.getTermPinCommand(this.$stateParams.termId).then(() => {
      this.dropCourseModal.$promise.then(() => {
        this.dropCourseBound = this.dropCourse.bind(this, action);
        this.ngComponentCommunicatorService.subscribe(
          TransientAccessCredEventNames.NEW_CRED_SAVED,
          this.dropCourseBound
        );

        this.ngComponentCommunicatorService.subscribe(
          TransientAccessCredEventNames.CRED_FORM_ENTRY_CANCELLED,
          this.closeModalBound
        );
        this.scheduledSectionRequestStateCommand([this.section.id], true);
        this.dropCourseModal.show();
      });
    });
  }
  closeModal() {
    this.scheduledSectionRequestStateCommand([this.section.id], false);
    this.dropCourseModal.hide();
    this.ngComponentCommunicatorService.release(TransientAccessCredEventNames.NEW_CRED_SAVED, this.dropCourseBound);

    this.ngComponentCommunicatorService.release(
      TransientAccessCredEventNames.CRED_FORM_ENTRY_CANCELLED,
      this.closeModalBound
    );
    this.resetTransientCredWorkflow();
    this.sectionPins = {};
  }
  onPinValueChanged(event: any) {
    const pin = event.detail.value;
    const isMultiSection = TermCourseServant.isMultiSectionCourse(this.section._course);
    if (isMultiSection) {
      const relatedSectionsIds = _4.compact(
        _4.map(this.ngMultiSectionServant.getScheduledSiblingSections(this.section), 'id')
      );
      _4.forEach(relatedSectionsIds, (sectionId: number) => {
        this.sectionPins[sectionId] = pin;
      });
    } else {
      this.sectionPins[this.section.id] = pin;
    }
  }

  private buildScheduledSectionMenu() {
    this.menuId = _4.uniqueId('course-dropdown-menu-');
    this.scheduledSectionMenuSettings = {
      subtitle: this.getMenuSubtitle(this.section),
      capHeight: true
    };
    const isMultiSection = TermCourseServant.isMultiSectionCourse(this.section._course);
    const menuOptionTitle = this.getMenuOptionTitle(isMultiSection);
    const menuMultiSecTitle = this.ngMultiSectionServant.getMenuTitle(this.section);
    const showRefreshSeatsMenuItem =
      this.ngScheduledSectionStatusServant.isSectionScheduled(this.section) ||
      this.ngScheduledSectionStatusServant.isStatusWaitlisted(this.section);

    this.scheduledSectionMenuItems = [
      {
        value: 'refresh_seat_availability',
        title: 'Refresh Seat Availability',
        visible: showRefreshSeatsMenuItem
      },
      {
        value: 'unschedule_course',
        title: `Unschedule ${menuOptionTitle}`,
        visible: this.ngScheduledSectionStatusServant.isSectionScheduled(this.section)
      },
      { value: 'drop_course', title: `Drop ${menuOptionTitle}`, visible: this.shouldShowDropCourseMenuItem() },
      {
        value: 'withdraw_course',
        title: 'Withdraw',
        visible: this.shouldShowWithdrawCourseMenuItem()
      },
      {
        value: 'remove_waitlist',
        title: 'Remove from waitlist',
        visible: this.ngScheduledSectionStatusServant.isStatusWaitlisted(this.section)
      },
      {
        value: 'unschedule_sections',
        title: `Unschedule ${menuMultiSecTitle}`,
        visible: this.shouldShowUnscheduleSectionsMenuItem(isMultiSection)
      },
      {
        value: 'drop_sections',
        title: `Drop ${menuMultiSecTitle}`,
        visible: this.shouldShowDropSectionsMenuItem(isMultiSection)
      },
      {
        value: 'drop_enforced_coreqs',
        title: this.getCoreqText(),
        visible: this.showDropCoreqMenuOption
      },
      {
        value: 'swap_section',
        title: 'Swap Time',
        visible: this.shouldShowSwapOptions
      },
      {
        value: 'swap_course',
        title: 'Swap Course',
        visible: this.shouldShowSwapCourseMenuItem()
      },
      {
        value: 'reschedule',
        title: 'Schedule Another Time',
        visible: this.shouldShowScheduleAnotherTimeMenuOption()
      }
    ].filter((item) => item.visible);

    const sectionIsRepeatable = _4.get(this.section, 'is_repeatable', false);
    const sectionIsCompleted = this.ngScheduledSectionStatusServant.isStatusCompleted(this.section);
    const sectionIsCompletedAndRepeatable = sectionIsCompleted && sectionIsRepeatable;
    const canWithdrawOrReschedule = sectionIsCompletedAndRepeatable || this.isRegisteredInProgressNotDroppable;
    if (canWithdrawOrReschedule) {
      this.scheduledSectionMenuItems = _4.filter(this.scheduledSectionMenuItems, { value: 'withdraw_course' });
      this.scheduledSectionMenuItems.push({
        value: 'reschedule',
        title: 'Schedule Another Time',
        visible: true
      });
    }
  }

  private getMenuSubtitle(section: ISection) {
    return `${section._course.cd} ${section._course.title} ${this.getSectionLabel(section)}`;
  }

  private getMenuOptionTitle(isMultiSection: boolean) {
    const menuOptionTitle = isMultiSection
      ? this.ngMultiSectionServant.getTruncatedSectionTypeName(this.section)
      : 'Course';

    return menuOptionTitle;
  }

  private shouldShowDropCourseMenuItem() {
    const isMultiSection = TermCourseServant.isMultiSectionCourse(this.section._course);
    return (
      this.ngScheduledSectionServant.isSectionRegistered(this.section) &&
      !isMultiSection &&
      !this.hasEnforcedRegisteredInProgressCoreqsRelated &&
      _4.isEmpty(this.linkedCourseIds)
    );
  }

  private shouldShowWithdrawCourseMenuItem() {
    return this.ngRegisteredSectionServant.canBeWithdrawn(this.section);
  }

  private shouldShowUnscheduleSectionsMenuItem(isMultiSection: boolean) {
    const noOfSiblings = _4.size(this.ngMultiSectionServant.getScheduledSiblingSections(this.section));
    const shouldShowUnscheduleSectionsMenuItem =
      isMultiSection && this.ngScheduledSectionStatusServant.isSectionScheduled(this.section) && noOfSiblings > 1;
    return shouldShowUnscheduleSectionsMenuItem;
  }

  private shouldShowDropSectionsMenuItem(isMultiSection: boolean) {
    const shouldShowDropSectionsMenuItem =
      isMultiSection &&
      this.ngScheduledSectionServant.isSectionRegistered(this.section) &&
      !this.hasEnforcedRegisteredInProgressCoreqsRelated;
    return shouldShowDropSectionsMenuItem;
  }

  private getCoreqText() {
    const totalCoreqsToDropCount = this.totalCoursesToDropCount - 1;
    const coreqText =
      totalCoreqsToDropCount > 0 ? `Drop Course and Corequisites(${totalCoreqsToDropCount})` : `Drop Course`;
    return coreqText;
  }

  private shouldShowSwapCourseMenuItem() {
    const isPlannedCourseLocked = this.ngTermCourseServant.isLocked(_4.get(this.section, '_course._planned_course'));
    const shouldShowSwapCourseMenuItem = this.shouldShowSwapOptions && !isPlannedCourseLocked;
    return shouldShowSwapCourseMenuItem;
  }

  private shouldShowScheduleAnotherTimeMenuOption() {
    const sectionIsRepeatable = _4.get(this.section, 'is_repeatable', false);
    const shouldShowScheduleAnotherTimeMenuOption = sectionIsRepeatable;
    return shouldShowScheduleAnotherTimeMenuOption;
  }

  private readonly __menuItemStrategy = new Strategy({
    refresh_seat_availability: () => this.ngRefreshSeatAvailabilityFacade.refreshSeats(this.section.id),
    unschedule_course: () => this.ngUnscheduleSectionFacade.unschedule(this.section),
    swap_section: () =>
      this.saveSwapFromSectionCommand(this.section).then(() =>
        this.ngSectionSwapServant.gotoSwapSectionMode(this.section)
      ),
    swap_course: () =>
      this.saveSwapFromSectionCommand(this.section).then(() =>
        this.ngSectionSwapServant.gotoSwapCourseMode(this.section._course)
      ),
    withdraw_course: () => this.$state.go('my.schedule.registration.withdraw', { sectionId: this.section.id }),
    reschedule: () => this.__onRescheduleMenuItemSelected(),
    drop_course: () =>
      this.dropUnscheduleAllPrompt({ id: SectionTileMenuEnum.DROP_COURSE, text: `Drop ${this.menuOptionTitle()}` }),
    drop_enforced_coreqs: () =>
      this.dropUnscheduleAllPrompt({
        id: SectionTileMenuEnum.DROP_ENFORCED_COREQS,
        text: `Drop ${this.menuOptionTitle()}`
      }),
    drop_sections: () =>
      this.dropUnscheduleAllPrompt({ id: SectionTileMenuEnum.DROP_SECTIONS, text: `Drop ${this.menuOptionTitle()}` }),
    unschedule_sections: () =>
      this.dropUnscheduleAllPrompt({
        id: SectionTileMenuEnum.UNSCHEDULE_SECTIONS,
        text: `Unschedule ${this.menuOptionTitle()}`
      }),
    remove_waitlist: () =>
      this.dropUnscheduleAllPrompt({ id: SectionTileMenuEnum.REMOVE_WAITLIST, text: `Remove from waitlist` })
  });

  private menuOptionTitle() {
    const isMultiSection = TermCourseServant.isMultiSectionCourse(this.section._course);
    const menuOptionTitle = isMultiSection
      ? this.ngMultiSectionServant.getTruncatedSectionTypeName(this.section)
      : 'Course';
    return menuOptionTitle;
  }

  private __onRescheduleMenuItemSelected() {
    let rescheduleUrl = 'my.schedule.registration.reschedule';
    const rescheduleParams = {
      courseId: this.section.course
    };

    if (!this.ngScheduledSectionServant.isSectionMultiSection(this.section)) {
      rescheduleUrl = 'my.schedule.registration.reschedule.sections';
      _4.merge(rescheduleParams, {
        sectionTypeId: this.section.section_type
      });
    }
    this.$state.go(rescheduleUrl, rescheduleParams);
  }

  private __onMenuItemSelectedEnded($event: CustomEvent) {
    const refreshMenuItemKey = 'refresh_seat_availability';
    const shouldCloseSectionDetail = $event.detail.value !== refreshMenuItemKey;
    if (shouldCloseSectionDetail) {
      this.ngComponentCommunicatorService.publish('CLOSE_SECTION_DETAIL_MODAL');
    }
    const invokeMenuStrategy = this.__menuItemStrategy.get($event.detail.value);
    invokeMenuStrategy();
  }

  dropCourse(action: IMenuAction) {
    if (this.ngPreventTransientAccessQuery.result.redirectToAuthWorkflow) {
      return this.ngComponentCommunicatorService.publish(TransientAccessCredEventNames.TOGGLE_CRED_STEPS);
    }
    return this.saveTermPinCommand(this.$stateParams.termId).then(() => {
      this.ngDropCourseFacade.dropCourseAndCoreqs(
        this.section,
        action,
        this.sectionPins,
        this.ngPreventTransientAccessQuery.result.output
      );
      this.closeModal();
    });
  }

  /**
   * This method is used in a different template - "calendar_scheduled_section_button.html"
   */
  getCalendarScheduledSectionButton() {
    const calendarScheduledSectionButtonOptions = _4.filter(
      this.scheduledSectionMenuItems,
      (item) => item.value !== 'refresh_seat_availability'
    );
    const showFirstButtonOption = calendarScheduledSectionButtonOptions[0];
    return showFirstButtonOption;
  }
}

class ScheduledSectionMenuComponent implements ng.IComponentOptions {
  public bindings: any;
  public controller: any;
  public templateUrl: string;
  constructor() {
    this.bindings = {
      section: '<',
      label: '@',
      aesthetic: '@'
    };
    this.controller = ScheduledSectionMenu;
    this.templateUrl =
      'capability-ng-scheduler/src/views/course_scheduler/components/scheduled_section_menu/scheduled_section_menu.html';
  }
}
angular.module('capability-ng-scheduler').component('scheduledSectionMenu', new ScheduledSectionMenuComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/components/scheduled_section_menu/scheduled_section_menu.ts